"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[642],{

/***/ 71206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ testimonial; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 1 modules
var asset_component = __webpack_require__(49738);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonial/default-props.js
/* harmony default export */ var default_props = ({
    quote: {
        topic: {},
        title: '"Now that we have monday.com Work OS as the backbone of our organization I feel I have an overview I can trust."',
        body: null
    },
    author: "Charlie MacGregor, Founder & CEO",
    company: {
        title: "The Student Hotel"
    }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonial/testimonial.scss.js




var mdScreenSize = "".concat(vp_sizes.MD, "px");
var StylesTestimonial = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e17st2q80"
})("display:flex;padding-top:64px;padding-bottom:64px;justify-content:center;height:100%;width:100%;.content{display:flex;gap:45px;width:65%;justify-content:center;flex-direction:column;.quote{font-size:1.875rem;margin-bottom:50px;}.author{display:flex;align-items:center;gap:25px;font-size:1rem;.author-image{width:60px;}.company{font-weight:700;line-height:24px;font-size:1rem;}}}@media (max-width:", mdScreenSize, "){padding:32px 16px;.content{width:100%;gap:24px;line-height:1.5rem;.author-details-container{.author-name{font-size:0.75rem;}.company{font-size:0.75rem;}}.quote{margin-bottom:0;}}}&.white{color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}&.black{color:#000;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonial/testimonial.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}









var Testimonial = function(param) {
    var quote = param.quote, asset = param.asset, author = param.author, company = param.company, backgroundColor = param.backgroundColor;
    var additionalClassName = (0,react.useMemo)(function() {
        if (!backgroundColor) return;
        return (0,segments_service/* isDarkTheme */.$o)(backgroundColor) ? "white" : "black";
    }, [
        backgroundColor
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StylesTestimonial, {
        className: classnames_default()("testimonial", additionalClassName),
        style: {
            backgroundColor: colors/* default */.Z[backgroundColor]
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, _object_spread({
                    titleClassName: "quote"
                }, quote)),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "author",
                    children: [
                        (asset === null || asset === void 0 ? void 0 : asset.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                            image: asset,
                            className: "author-image"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "author-details-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "author-name",
                                    children: author
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, _object_spread({
                                    titleClassName: "company"
                                }, company))
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial = (Testimonial);
Testimonial.defaultProps = default_props;


/***/ }),

/***/ 10642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CAROUSEL_SETTINGS": function() { return /* binding */ CAROUSEL_SETTINGS; },
  "default": function() { return /* binding */ carousel_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./segments/desktop/core-components/testimonial/testimonial.js + 2 modules
var testimonial_testimonial = __webpack_require__(71206);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 1 modules
var asset_component = __webpack_require__(49738);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/components/tab-content/components/statistic/statistic-component.scss.js



var StyledStatisticComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1azu4b0"
})("display:flex;gap:16px;align-items:center;.vertical-line{height:100%;width:4px;border-radius:6px;background-color:", function(param) {
    var lineColor = param.lineColor;
    return colors/* default */.Z[lineColor];
}, ";margin-right:", function(param) {
    var lineMargin = param.lineMargin;
    return lineMargin || "24px";
}, ";}@media (max-width:", vp_sizes/* MID_HEADER_DESKTOP_MENU */.vc, "px){.full-paragraph{.title-wrapper{margin-bottom:12px;.core-title-container .core-title{font-size:1.75rem;line-height:40px;}}.paragraph-body-wrapper{.paragraph-wrapper .paragraph-body{font-size:1rem;line-height:24px;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/components/tab-content/components/statistic/statistic-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var DEFAULT_STAT_CONTENT = {
    topic: {}
};
var StatisticComponent = function(param) {
    var statics = param.statics, advancedStaticsConfig = param.advancedStaticsConfig;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStatisticComponent, {
        lineColor: statics === null || statics === void 0 ? void 0 : statics.lineColor,
        lineMargin: advancedStaticsConfig === null || advancedStaticsConfig === void 0 ? void 0 : advancedStaticsConfig.lineMargin,
        className: "statistic-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "vertical-line"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({}, DEFAULT_STAT_CONTENT, statics, advancedStaticsConfig))
        ]
    });
};
/* harmony default export */ var statistic_component = (StatisticComponent);

// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/components/tab-content/tab-content-component.scss.js



var TESTIMONIAL_CONTENT_GAP = "32px";
var StyledTabContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1c2f8f80"
})("position:relative;.asset-inner{z-index:", z_index/* LAYER_ONE */.KW, ";video,img{border-radius:20px;}}.content-wrapper{padding:calc(max(100vw / ", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, " * 80,12px));z-index:", z_index/* LAYER_TWO */.wc, ";position:absolute;display:flex;justify-content:space-between;left:0;top:0;width:100%;height:100%;.testimonial-wrapper{display:flex;width:fit-content;flex-direction:column;gap:", TESTIMONIAL_CONTENT_GAP, ";.testimonial{padding:0;max-width:", function(param) {
    var testimonialMaxWidth = param.testimonialMaxWidth;
    return testimonialMaxWidth || "100%";
}, ";width:fit-content;justify-content:flex-start;.content{width:fit-content;justify-content:flex-end;gap:", TESTIMONIAL_CONTENT_GAP, ";.quote{font-size:1.25rem;line-height:32px;margin-bottom:0;}.author{gap:16px;.asset-inner.author-image{width:40px;}}@media (max-width:", vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px){.quote{font-size:1.125rem;}}}}}.stats-section{display:flex;flex-direction:column;justify-content:center;gap:32px;@media (max-width:", vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px){gap:16px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/components/tab-content/tab-content-component.js
function tab_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tab_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tab_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}






var TabContentComponent = function(param) {
    var testimonial = param.testimonial, asset = param.asset, stats = param.stats, tabAdvancedConfig = param.tabAdvancedConfig, advancedAssetProps = param.advancedAssetProps;
    var _testimonial_button, _testimonial_button1, _testimonial_button2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabContentComponent, {
        testimonialMaxWidth: tabAdvancedConfig === null || tabAdvancedConfig === void 0 ? void 0 : tabAdvancedConfig.testimonialMaxWidth,
        className: "tab-content-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, tab_content_component_object_spread({}, asset, advancedAssetProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "testimonial-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(testimonial_testimonial/* default */.Z, tab_content_component_object_spread({}, testimonial)),
                            (testimonial === null || testimonial === void 0 ? void 0 : testimonial.button) && /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, {
                                isWithArrow: true,
                                color: (_testimonial_button = testimonial.button) === null || _testimonial_button === void 0 ? void 0 : _testimonial_button.color,
                                url: (_testimonial_button1 = testimonial.button) === null || _testimonial_button1 === void 0 ? void 0 : _testimonial_button1.buttonUrl,
                                buttonText: (_testimonial_button2 = testimonial.button) === null || _testimonial_button2 === void 0 ? void 0 : _testimonial_button2.buttonText,
                                isOpenLinkInNewTab: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "stats-section",
                        children: stats === null || stats === void 0 ? void 0 : stats.map(function(statics, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(statistic_component, {
                                advancedStaticsConfig: tabAdvancedConfig === null || tabAdvancedConfig === void 0 ? void 0 : tabAdvancedConfig.advancedStatsConfig,
                                statics: statics
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var tab_content_component = (TabContentComponent);

// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/custom-hooks/use-slides-to-show.js


var useSlidesToShow = function() {
    var ref = (0,react.useState)(1), slidesToShow = ref[0], setSlidesToShow = ref[1];
    var getSlidesToShow = (0,react.useCallback)(function() {
        var screenWidth = window.innerWidth;
        if (screenWidth < vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld) return 1;
        var slidesContainerWidth = screenWidth - (screenWidth - vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld) / 2;
        var slidesInScreen = slidesContainerWidth / vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld;
        setSlidesToShow(slidesInScreen);
    }, []);
    (0,react.useEffect)(function() {
        getSlidesToShow();
        window.addEventListener("resize", getSlidesToShow);
        return function() {
            window.removeEventListener("resize", getSlidesToShow);
        };
    }, [
        getSlidesToShow
    ]);
    return slidesToShow;
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/components/tabs-labels/tabs-labels-component.scss.js



var StyledTabsLabelsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eyvxh8f0"
})("display:flex;gap:24px;cursor:pointer;padding:0 ", constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px;.label{flex:1;display:flex;flex-direction:column;img{height:", function(param) {
    var tabLabelHeight = param.tabLabelHeight;
    return tabLabelHeight || "32px";
}, ";object-fit:contain;opacity:0.5;transition:opacity 0.3s ease-in-out;}&.selected{&.active{img{opacity:1;}.underline-placeholder::after{animation:fill-progress-bar linear forwards;animation-duration:", function(param) {
    var transitionTime = param.transitionTime;
    return "".concat(transitionTime, "ms");
}, ';}}&:not(.active){.underline-placeholder::after{width:100%;}}}.underline-placeholder{margin-top:24px;background-color:rgba(255,255,255,0.2);position:relative;height:6px;bottom:0;left:0;right:0;border-radius:40px;&::after{content:"";position:absolute;width:0;height:100%;background-color:', function(param) {
    var progressbarColor = param.progressbarColor;
    return colors/* default */.Z[progressbarColor] || colors/* default.White */.Z.White;
}, ";left:0;right:0;border-radius:40px;}}@keyframes fill-progress-bar{from{width:0;}to{width:100%;}}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/components/tabs-labels/tabs-labels-component.js




var TabsLabelsComponent = function(param) {
    var labels = param.labels, selectedLabelIndex = param.selectedLabelIndex, progressbarColor = param.progressbarColor, transitionTime = param.transitionTime, onSelectionChanges = param.onSelectionChanges, tabLabelHeight = param.tabLabelHeight;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTabsLabelsComponent, {
        tabLabelHeight: tabLabelHeight,
        progressbarColor: progressbarColor,
        transitionTime: transitionTime,
        className: "tabs-labels-component",
        children: labels.map(function(label, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function() {
                    return onSelectionChanges(index);
                },
                className: classnames_default()("label", {
                    active: !!transitionTime,
                    selected: selectedLabelIndex === index
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                        image: {
                            src: label
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "underline-placeholder"
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var tabs_labels_component = (TabsLabelsComponent);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/carousel-tabs-component.scss.js



var StyledCarouselTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1dt3hw90"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;min-width:990px;.carousel-tabs-container{display:flex;flex-direction:column;gap:", function(param) {
    var containerGap = param.containerGap;
    return containerGap || "32px";
}, ";.carousel{.slick-track{display:flex;.slick-slide{border-radius:20px;transition:opacity 0.5s;&.slick-current{padding:0 ", constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px;}&:not(.slick-current){padding-right:", constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING * 2, "px;}&.slick-current{opacity:1;}&:not(.slick-current){opacity:0.5;cursor:pointer;}}}@media (min-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px){margin-right:calc((100vw - ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px) / -2);}}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/carousel-tabs-component.js
function carousel_tabs_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_tabs_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_tabs_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var CAROUSEL_SETTINGS = {
    defaultIndex: 0,
    infinite: false,
    centerMode: false,
    swipe: false,
    draggable: false,
    dots: false
};
var CarouselTabsComponent = function(param) {
    var tabs = param.tabs, transitionTime = param.transitionTime, progressbarColor = param.progressbarColor, tabAdvancedConfig = param.tabAdvancedConfig, isInView = param.isInView, containerGap = param.containerGap, tabLabelHeight = param.tabLabelHeight, autoPlayWhenVisible = param.autoPlayWhenVisible, advancedAssetProps = param.advancedAssetProps;
    var slidesToShow = useSlidesToShow();
    var slider = (0,react.useRef)(null);
    var parsedTransitionTime = parseInt(transitionTime);
    var ref = (0,react.useState)(0), selectedTab = ref[0], setSelectedTab = ref[1];
    var labels = (0,react.useMemo)(function() {
        return tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab) {
            return tab.tabLabel;
        });
    }, [
        tabs
    ]);
    var slides = (0,react.useMemo)(function() {
        return tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab) {
            return tab.tabContent;
        });
    }, [
        tabs
    ]);
    var onSelectionChanges = (0,react.useCallback)(function(index) {
        setSelectedTab(index);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_TAB_CLICKED, {
            info1: index + 1
        });
    }, []);
    (0,react.useEffect)(function() {
        if (!parsedTransitionTime || autoPlayWhenVisible && !isInView) return;
        var interval = setInterval(function() {
            setSelectedTab((selectedTab + 1) % (tabs === null || tabs === void 0 ? void 0 : tabs.length));
        }, parsedTransitionTime);
        return function() {
            clearInterval(interval);
        };
    }, [
        tabs === null || tabs === void 0 ? void 0 : tabs.length,
        parsedTransitionTime,
        isInView,
        autoPlayWhenVisible,
        selectedTab
    ]);
    (0,react.useEffect)(function() {
        slider === null || slider === void 0 ? void 0 : slider.current.scrollToSlide(selectedTab);
    }, [
        selectedTab
    ]);
    var tabRenderer = (0,react.useCallback)(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tab_content_component, _object_spread_props(carousel_tabs_component_object_spread({}, item), {
            tabAdvancedConfig: tabAdvancedConfig,
            advancedAssetProps: advancedAssetProps
        }));
    }, [
        advancedAssetProps,
        tabAdvancedConfig
    ]);
    var onSlideChange = function(index) {
        var didChangedByClick = index !== selectedTab;
        if (didChangedByClick) {
            setSelectedTab(index);
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_TAB_CLICKED, {
                info1: index + 1
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarouselTabsComponent, {
        containerGap: containerGap,
        className: "carousel-tabs-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "carousel-tabs-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_labels_component, {
                    tabLabelHeight: tabLabelHeight,
                    slidesToShow: slidesToShow,
                    selectedLabelIndex: selectedTab,
                    transitionTime: autoPlayWhenVisible && !isInView ? null : parsedTransitionTime,
                    onSelectionChanges: onSelectionChanges,
                    progressbarColor: progressbarColor,
                    labels: labels
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, carousel_tabs_component_object_spread({
                    onChange: onSlideChange,
                    slidesToShow: slidesToShow,
                    itemRenderer: tabRenderer,
                    items: slides,
                    ref: slider
                }, CAROUSEL_SETTINGS))
            ]
        })
    });
};
/* harmony default export */ var carousel_tabs_component = (CarouselTabsComponent);


/***/ })

}]);